import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, FlexRow, MyInfoIcon, SmallGrayText, SmallText, ToolTipHover } from '@guryou/html-components';
import { borderDefinition } from '@guryou/html-theme';

const addMinutesToTime = (startTime, minutesToAdd) => {
  let [hours, minutes] = startTime.split(':').map(Number);

  minutes += minutesToAdd;
  hours += Math.floor(minutes / 60);
  minutes = ((minutes % 60) + 60) % 60;
  if (minutesToAdd < 0 && minutes > 0) {
    hours--;
  }
  hours = (hours + 24) % 24;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

export const HoursExample = ({ timeStep }) => {
  const { t } = useTranslation();
  const first = addMinutesToTime('14:00', timeStep);
  const second = addMinutesToTime(first, timeStep);
  const third = addMinutesToTime(first, timeStep * 2);
  return (
    <FlexRow margin={0}>
      <Block margin={0} display="flex" flexDirection="row" alignItems="start" justifyContent="start">
        <SmallGrayText marginRight={2}>{t('ONBOARD.reservationTimeExample')}</SmallGrayText>
        <ToolTipHover cleanToolTip={true} label={<MyInfoIcon fontSize="small" />} text={t('ONBOARD.minSlotExplainText')} />
      </Block>
      <Block xs={5} margin={0} marginTop={1} padding={0} border={borderDefinition()}>
        <SmallText xs={12} margin={0} padding={1.2} backgroundColor="lightgray">
          {first}
        </SmallText>
        <SmallText xs={12} padding={1.2}>
          {second}
        </SmallText>
        <SmallText xs={12} padding={1.2}>
          {third}
        </SmallText>
      </Block>
    </FlexRow>
  );
};

const CalendarDuration = ({ value, timeStep = 0, preparationTime = 0 }) => {
  const { t } = useTranslation();

  const calculatePreparationPercentage = (duration, preparationTime) => {
    if (duration <= 0) {
      return [100, 0];
    }
    const preparationPercentage = (preparationTime / duration) * 100;
    const durationPercentage = 100 - preparationPercentage;
    return durationPercentage;
  };

  const calculateColor = (color, duration, preparationTime) => {
    const dp = calculatePreparationPercentage(duration, preparationTime);
    const firstStop = `${color} 0%, ${color} ${dp}%`;
    const secondStop = `#D3D3D3 ${dp}%, #D3D3D3 100%`;
    return `linear-gradient(to bottom, ${firstStop}, ${secondStop})`;
  };

  return (
    <Block xs={12} padding={0} height="250px" border="1px solid lightgray">
      <Block xs={12} margin={0} height="50px" borderBottom="1px solid lightgray">
        <FlexRow height="100%" width="100%" margin={0} padding={0}>
          <Block width="10%" margin={0} height="inherit" borderRight="1px solid lightgray">
            <SmallText>13:00</SmallText>
          </Block>
          <Block width="90%" margin={0} height="inherit"></Block>
        </FlexRow>
      </Block>
      <Block xs={12} position="relative" margin={0} height="50px" borderBottom="1px solid lightgray" overflow="visible">
        <FlexRow height="100%" width="100%" margin={0} padding={0} overflow="visible">
          <Block width="10%" margin={0} height="inherit" borderRight="1px solid lightgray">
            <SmallText>14:00</SmallText>
          </Block>
          <Block
            position="absolute"
            left="10%"
            width="90%"
            margin={0}
            top={`${timeStep * 1.67}%`}
            height={`${value * 1.67 + 2}%`}
            background={calculateColor('green', value, preparationTime)}
            overflow="hidden"
          >
            <SmallText color="white" marginLeft={1} fontSize="0.65rem">
              Mario Rossi
            </SmallText>
            <SmallText color="white" marginLeft={1} fontSize="0.65rem">
              {`${t('GENERAL.from')}:`} {addMinutesToTime('14:00', timeStep)} {`${t('GENERAL.to')}:`} {addMinutesToTime('14:00', value + timeStep)}
            </SmallText>
            <SmallText color="white" marginLeft={1} fontSize="0.65rem">
              Massaggi corpo
            </SmallText>
          </Block>
        </FlexRow>
      </Block>
      <Block xs={12} margin={0} height="50px" borderBottom="1px solid lightgray">
        <FlexRow height="100%" width="100%" margin={0} padding={0}>
          <Block width="10%" margin={0} height="inherit" borderRight="1px solid lightgray">
            <SmallText>15:00</SmallText>
          </Block>
          <Block width="90%" margin={0} height="inherit"></Block>
        </FlexRow>
      </Block>
      <Block xs={12} margin={0} height="50px" borderBottom="1px solid lightgray">
        <FlexRow height="100%" width="100%" margin={0} padding={0}>
          <Block width="10%" margin={0} height="inherit" borderRight="1px solid lightgray">
            <SmallText>16:00</SmallText>
          </Block>
          <Block width="90%" margin={0} height="inherit"></Block>
        </FlexRow>
      </Block>
      <Block xs={12} margin={0} height="50px">
        <FlexRow height="100%" width="100%" margin={0} padding={0}>
          <Block width="10%" margin={0} height="inherit" borderRight="1px solid lightgray">
            <SmallText>17:00</SmallText>
          </Block>
          <Block width="90%" margin={0} height="inherit"></Block>
        </FlexRow>
      </Block>
    </Block>
  );
};

export default CalendarDuration;
